import { ReactNode, useEffect, useState } from "react";
import { ButtonsHandlerProps, ButtonsProps } from "../Buttons.types";
import { ChevronDown } from 'icons/indexed-icons/ChevronDown'
import { OpenCloseToggleButtonContainer } from "./OpenCloseToggleButton.elements";

export interface OpenCloseToggleButtonProps extends ButtonsProps {
  handleOpen?:ButtonsHandlerProps,
  handleClose?: ButtonsHandlerProps,
  iconLocation?: 'left' | 'right',
  children?: ReactNode,
  isOpen?: boolean,
  className?: string,
 }
export const OpenCloseToggleButton = ({
  children,
  handleOpen,
  handleClose,
  handleClick,
  iconLocation = 'right',
  isOpen = false,
  Icon = ChevronDown,
  className
}: OpenCloseToggleButtonProps) => {
  
  const [open, setIsOpen] = useState(isOpen)
  
  useEffect(() => {
    if (open) return handleOpen?.()
    else return handleClose?.()
  }, [open])
  
  useEffect(() => {
    setIsOpen(isOpen)
  }, [isOpen])

  className = `open-close-button ${className || ``}`.trim()

  if (open || isOpen) className += ` is-open`
  else className += ` is-closed`

  return (
    <OpenCloseToggleButtonContainer className={className} onClick={() => {
      setIsOpen(!open)
      return handleClick?.(String(children))
    }}>
      <span className='label'>{children}</span>
       <Icon />
    </OpenCloseToggleButtonContainer>
  )
}